/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminPrintLabelResponse
 */
export interface AdminPrintLabelResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminPrintLabelResponse
     */
    message?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminPrintLabelResponse
     */
    success?: boolean;
}

export function AdminPrintLabelResponseFromJSON(json: any): AdminPrintLabelResponse {
    return AdminPrintLabelResponseFromJSONTyped(json, false);
}

export function AdminPrintLabelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPrintLabelResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
        'success': !exists(json, 'success') ? undefined : json['success'],
    };
}

export function AdminPrintLabelResponseToJSON(value?: AdminPrintLabelResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'success': value.success,
    };
}

